<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20 mb-30">회원관리 > 공인중개사 > 상세정보</h4>
        <div class="col-11">
          <p class="ml-10 fl" style="width: 80%">
            공인중개사 회원관리 페이지입니다.
          </p>
          <router-link to="/mypage/admin/mem/agt">
            <el-button class="fr" icon="el-icon-menu">목록보기</el-button>
          </router-link>
        </div>
        <div class="col-12 row">
          <div class="row col-12 ml-10">
            <!-- 주소 -->
            <h4 class="col-12 pl-0">매물정보</h4>
            <div class="col-sm-6 pl-0 dashbrd-el-label">
              <h5 class="fl ttl-label mr-20 mb-20">회원구분</h5>
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="일반" checked></el-checkbox>
                <el-checkbox label="카카오톡"></el-checkbox>
                <el-checkbox label="네이버"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="col-sm-6 pl-0 dashbrd-el-label">
              <h5 class="fl ttl-label mr-20 mb-20">회원종류</h5>
              <el-checkbox-group v-model="checkList2">
                <el-checkbox label="임대인"></el-checkbox>
                <el-checkbox label="공인중개사" checked></el-checkbox>
                <el-checkbox label="일반"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="col-sm-6 pl-0 dashbrd-el-label">
              <h5 class="fl ttl-label mr-20 mb-20">가입상태</h5>
              <el-checkbox-group v-model="checkList3">
                <el-checkbox label="가입요청" checked></el-checkbox>
                <el-checkbox label="가입승인"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="col-10 mb-30 ml-10">
          <h4>일반정보</h4>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">성명</template>
          </el-input>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">휴대전화</template>
          </el-input>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">성별</template>
          </el-input>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">생년월일</template>
          </el-input>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">이메일</template>
          </el-input>
          <el-input class="col-md-4 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">수신용이메일</template>
          </el-input>
        </div>
        <div class="col-10 mb-30 ml-10">
          <h4>일반정보</h4>
          <el-input class="col-md-6 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">대표자명</template>
          </el-input>
          <el-input class="col-md-6 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">상호명</template>
          </el-input>
          <el-input class="col-md-6 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">등록번호</template>
          </el-input>
          <el-input class="col-md-6 col-sm-6 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">등록증</template>
          </el-input>
        </div>
        <div class="col-11 ml-10">
          <h4>메모</h4>
          <ckeditor
            class="col-11 mb-30 pl-0"
            v-model="editorDataMemo"
            :config="editorConfig"
          ></ckeditor>
        </div>
        <div class="col-3 m-auto">
          <el-button class=""> 수정 </el-button>
          <el-button class="" style="margin-left: 10px"> 삭제 </el-button>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import card from "@/components/Cards/Card.vue";
import CKEditor from "ckeditor4-vue";
import { Input, Button, Checkbox, CheckboxGroup } from "element-ui";
import kakao from "@/pages/jipvio/kakaoMap.vue";

export default {
  components: {
    card,
    ckeditor: CKEditor.component,
    [Input.name]: Input,
    [Button.name]: Button,
    kakao,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  created() {
    console.log("===detail");
  },
  computed: {},
  data() {
    return {
      checkList: [""],
      checkList2: [""],
      checkList3: [""],
      input: "",
      editorDataMemo: "<p>내용을 입력해주세요.</p>",
      editorConfig: {
        toolbar: [
          ["Styles", "Format", "Font", "FontSize"],
          ["Bold", "Italic"],
          ["TextColor", "BGColor"],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language"
          ],
          ["Table"],
          ["Link"],
          ["Undo", "Redo"],
          ["About"]
        ]
        // The configuration of the editor.
      }
    };
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
<style>
.jipvio-dashboard .el-input__suffix {
  right: 14px;
}
div.KakaoMap > div {
  width: 100%;
}
div#map {
  width: 600px;
  height: 500px;
  margin: 0 auto !important;
}
div#map ~ button {
  display: none;
}
</style>
